import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNotification } from '../../contexts/NotificationContext';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiX, FiCheck, FiAlertTriangle, FiInfo, FiAlertCircle } = FiIcons;

const notificationIcons = {
  success: FiCheck,
  error: FiAlertCircle,
  warning: FiAlertTriangle,
  info: FiInfo
};

const notificationStyles = {
  success: 'bg-green-50 border-green-200 text-green-800',
  error: 'bg-red-50 border-red-200 text-red-800',
  warning: 'bg-yellow-50 border-yellow-200 text-yellow-800',
  info: 'bg-blue-50 border-blue-200 text-blue-800'
};

export default function NotificationCenter() {
  const { notifications, removeNotification } = useNotification();

  return (
    <div className="fixed top-4 right-4 z-50 space-y-2">
      <AnimatePresence>
        {notifications.map((notification) => (
          <motion.div
            key={notification.id}
            initial={{ opacity: 0, x: 100, scale: 0.8 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            exit={{ opacity: 0, x: 100, scale: 0.8 }}
            transition={{ duration: 0.3, type: 'spring' }}
            className={`
              max-w-sm p-4 rounded-lg border shadow-lg
              ${notificationStyles[notification.type]}
            `}
          >
            <div className="flex items-start">
              <SafeIcon
                icon={notificationIcons[notification.type]}
                className="w-5 h-5 mt-0.5 mr-3 flex-shrink-0"
              />
              
              <div className="flex-1 min-w-0">
                {notification.title && (
                  <p className="font-medium">{notification.title}</p>
                )}
                <p className="text-sm">{notification.message}</p>
              </div>

              <button
                onClick={() => removeNotification(notification.id)}
                className="ml-3 flex-shrink-0 text-gray-400 hover:text-gray-600"
              >
                <SafeIcon icon={FiX} className="w-4 h-4" />
              </button>
            </div>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}